import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/wnvvdlra_Logo%20Firefly%20Upscaler%204x%20scale%20copy.png";

export const Footer = () => {
  const { footer } = mockData;

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          {/* Logo & Tagline */}
          <div className="space-y-4">
            <img
              src={LOGO_URL}
              alt="Grabo.ai"
              className="h-8 w-auto brightness-0 invert"
            />
            <p className="text-3xl font-bold text-[#2AD7C5]">{footer.tagline}</p>
            <p className="text-gray-400 text-sm">
              AI-powered retail for premium locations
            </p>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <a
              href={`tel:${footer.phone}`}
              className="flex items-center gap-2 text-gray-300 hover:text-[#2AD7C5] transition-colors"
            >
              <Phone size={18} />
              <span>{footer.phone}</span>
            </a>
            <a
              href={`mailto:${footer.email}`}
              className="flex items-center gap-2 text-gray-300 hover:text-[#2AD7C5] transition-colors"
            >
              <Mail size={18} />
              <span>{footer.email}</span>
            </a>
            <div className="flex items-center gap-2 text-gray-300">
              <MapPin size={18} />
              <span>{footer.location}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-[#2AD7C5] transition-colors"
                >
                  How it Works
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('use-cases')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-[#2AD7C5] transition-colors"
                >
                  Use Cases
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-[#2AD7C5] transition-colors"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-[#2AD7C5] transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">{footer.copyright}</p>
            <div className="flex items-center gap-6 text-sm text-gray-400">
              <a href="#" className="hover:text-[#2AD7C5] transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-[#2AD7C5] transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
